<template>
  <cooperationItem :data="data"/>
</template>

<script>
import listItem from "@/components/liffList/listItem.js";

export default {
  mixins: [listItem],
  components: {
    cooperationItem: () => import("@/modules/store/views/cooperationItem/cooperationItem.vue"),
  },
};
</script>